import * as actiontypes from '../actions/actionTypes';
import initialState from '../store/initialState';

const success = (state = initialState.success, action) => {
    switch (action.type) {
        case actiontypes.SUBMIT_FORM_SUCCESS:

            return action.success
        default:
            return state
    }
}

export default success


// WEBPACK FOOTER //
// ./src/reducers/formReducer.js